<template>
  <div class="gantt-chart-wrapper h-full">
    <g-gantt-chart
      :chart-start="chartStart"
      :chart-end="chartEnd"
      precision="hour"
      width="100%"
      bar-start="myBeginDate"
      bar-end="myEndDate"
      current-time
      grid
      class="custom-gantt-chart"
      @click-bar="handleBarClick"
    >
      <g-gantt-row
        v-for="(row, idx) in rows"
        :key="idx"
        :label="row.label"
        :bars="row.bars"
        class="gantt-row-hover"
        style="cursor: pointer"
      >
        <template #label>
          <div
            class="gantt-row-label-clickable"
            @click.stop="handleSelectService(row)"
          >
            {{ row.label }}
          </div>
        </template>
      </g-gantt-row>
    </g-gantt-chart>
  </div>
</template>

<script>
export default {
  props: {
    chartStart: {
      type: String,
    },
    chartEnd: {
      type: String,
    },
    rows: {
      type: Array,
      required: true,
    },
  },
  emits: ["select-service", "select-bar"],
  methods: {
    handleSelectService(row) {
      this.$emit("select-service", row);
    },
    handleBarClick({ bar, e, datetime }) {
      // Find the row that contains this bar
      const row = this.rows.find(r => r.bars.some(b => b === bar));
      this.$emit("select-bar", { bar, row, event: e, datetime });
    },
  },
};
</script>

<style scoped>
.gantt-chart-wrapper {
  background-color: white;
}

.custom-gantt-chart {
  height: 100%;
}

.gantt-row-hover:hover {
  background-color: rgb(248 250 252);
}

/* Mejoras visuales para el Gantt Chart */
:deep(.g-gantt-chart) {
  border-radius: 0.5rem;
}

:deep(.g-gantt-row-label) {
  font-weight: 500;
  font-size: 0.875rem;
  color: #1a1a1a;
}

:deep(.g-gantt-bar) {
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  transition: all 0.2s ease;
}

:deep(.g-gantt-bar:hover) {
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  transform: translateY(-1px);
}

:deep(.g-timeaxis) {
  font-size: 0.75rem;
  color: #6b7280;
}

:deep(.g-grid-line) {
  opacity: 0.3;
}

:deep(.g-timeaxis-hour) {
  border-color: #e2e8f0;
}

:deep(.g-gantt-row) {
  transition: background-color 0.2s ease;
}

.gantt-row-label-clickable {
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #1a1a1a;
  transition: color 0.2s ease;
  width: 100%;
}

.gantt-row-label-clickable:hover {
  color: #f97316; /* eorange-500 */
}

/* Unavailable time ranges - diagonal stripes */
:deep(.g-gantt-bar.bar-unavailable) {
  cursor: not-allowed;
  pointer-events: all;
  opacity: 0.6;
}

/* Available but empty slots - transparent with dashed border */
:deep(.g-gantt-bar.bar-available-empty) {
  background: transparent !important;
  border: 2px dashed #22c55e !important;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

:deep(.g-gantt-bar.bar-available-empty:hover) {
  opacity: 1;
  border-color: #16a34a !important;
}

/* Booked slots - keep existing styles */
:deep(.g-gantt-bar.bar-booked) {
  /* Styles are applied inline via ganttBarConfig.style */
}

/* Color coding for bars based on utilization (legacy - kept for reference) */
:deep(.g-gantt-bar.bar-full) {
  background-color: #ef4444 !important;
}

:deep(.g-gantt-bar.bar-high) {
  background-color: #f97316 !important;
}

:deep(.g-gantt-bar.bar-partial) {
  background-color: #eab308 !important;
}

:deep(.g-gantt-bar.bar-empty) {
  background-color: #22c55e !important;
}
</style>
